const SubAbasFornecedores = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/fornecedores/fornecedores/${id}/dadosgerais`,
  },
  /*{
    label: 'Representantes',
    rota: `/daf/fornecedores/fornecedores/ficha/${id}/representantes`,
  },*/
  /*{
    label: 'Representantes',
    rota: `/daf/fornecedores/fornecedores/ficha/${id}/pr`,
  },*/
  // {
  //   label: 'Histórico de Registro',
  //   rota: `/daf/fornecedores/fornecedores/ficha/${id}/historicort`,
  // },
  {
    label: 'Registro de Comunicações',
    rota: `/daf/fornecedores/fornecedores/${id}/comunicacoes`,
  },
];

export default SubAbasFornecedores;
